'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { Radio } from '@pickleballinc/react-ui';
import { Controller, FormProvider, useForm } from 'react-hook-form';

import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';
import { CaptainManagerDesignationData, captainManagerDesignationSchema } from '@/entities';
import { TeamLeaguePlayerStatus } from '@/entities/TeamPlayerInfo';

interface CaptainManagerDesignationFormProp {
	title: string;
	teamName: string;
	onClose: () => void;
	onSubmit: (data: CaptainManagerDesignationData) => void;
	playerStatus: TeamLeaguePlayerStatus;
}

export const CaptainManagerDesignationForm = ({ title, teamName, onClose, onSubmit, playerStatus }: CaptainManagerDesignationFormProp) => {
	const form = useForm<CaptainManagerDesignationData>({
		resolver: zodResolver(captainManagerDesignationSchema),
		defaultValues: {
			role: playerStatus
		}
	});

	const { handleSubmit, control, formState } = form;

	form.handleSubmit(onSubmit);
	return (
		<ModalWrapper title={title} onClose={onClose} className="!gap-6">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="flex flex-col gap-5">
					<p className="text-lg flex font-semibold text-gray-500">{teamName}</p>

					<div className="flex flex-col gap-6">
						<Controller
							name="role"
							control={control}
							render={({ field }) => (
								<div className="flex flex-col gap-4">
									<div onClick={() => field.onChange(TeamLeaguePlayerStatus.TEAM_PLAYER)} className="flex items-center">
										<Radio
											radioTheme="orange"
											type="radio"
											name="role"
											value={TeamLeaguePlayerStatus.TEAM_PLAYER}
											checked={field.value === TeamLeaguePlayerStatus.TEAM_PLAYER}
											onChange={() => field.onChange(TeamLeaguePlayerStatus.TEAM_PLAYER)}
											className="size-5 cursor-pointer"
										/>
										<label className="text-md ml-2 cursor-pointer">Non-captain</label>
									</div>

									<div onClick={() => field.onChange(TeamLeaguePlayerStatus.TEAM_CAPTAIN)} className="flex  items-center">
										<Radio
											radioTheme="orange"
											type="radio"
											name="role"
											value={TeamLeaguePlayerStatus.TEAM_CAPTAIN}
											checked={field.value === TeamLeaguePlayerStatus.TEAM_CAPTAIN}
											onChange={() => field.onChange(TeamLeaguePlayerStatus.TEAM_CAPTAIN)}
											className="size-5 cursor-pointer"
										/>
										<label className="text-md ml-2 cursor-pointer">Captain</label>
									</div>

									<div onClick={() => field.onChange(TeamLeaguePlayerStatus.TEAM_CAPTAIN_ASSISTANCE)} className="flex items-center">
										<Radio
											radioTheme="orange"
											type="radio"
											name="role"
											value={TeamLeaguePlayerStatus.TEAM_CAPTAIN_ASSISTANCE}
											checked={field.value === TeamLeaguePlayerStatus.TEAM_CAPTAIN_ASSISTANCE}
											onChange={() => field.onChange(TeamLeaguePlayerStatus.TEAM_CAPTAIN_ASSISTANCE)}
											className="size-5 cursor-pointer"
										/>
										<label className="text-md ml-2 cursor-pointer">Co-captain</label>
									</div>
								</div>
							)}
						/>
					</div>

					<hr className="h-px rounded-xl bg-brand-300" />

					<ActionButtons
						className="justify-end"
						onClose={onClose}
						submitButtonText="Save"
						closeButtonText="Cancel"
						submitButtonDisabled={formState.isSubmitting || !formState.isDirty}
						submitButtonClassName="text-white"
					/>
				</form>
			</FormProvider>
		</ModalWrapper>
	);
};
